// Figure out how to get  httpOnly=true
export function getCookie(key: string): string {
  interface Cookies {
    [key: string]: string;
  }

  const cookies: Cookies = {};

  const pairs = document.cookie.split(";");

  pairs.forEach((pair) => {
    const [key, value] = pair.split("=");
    if (key && value) {
      cookies[key.trim()] = decodeURIComponent(value.trim());
    }
  });

  return cookies[key];
}

export function setCookie(
  key: string,
  value: string,
  maxAge: number = 2592000
): void {
  document.cookie = `${key}=${value}; path='/'; max-age=${maxAge};`; // 30 days in seconds
}

export function clearCookies(): void {
  document.cookie.split(";").forEach(function (c) {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });
}
